<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

@if (showNotice) {
  <div class="xrx-card cookie-consent" role="contentinfo">
    <div class="cookie-consent-text">
      <span
        [xdaTranslate]="'SDE_FMTSTR_USES_COOKIES'"
        [formatValues]="'FULL_APPNAME'"></span>
      <span xdaTranslate>SDE_VIEW_OUR</span>&nbsp;<a
        class="notice-link"
        href="https://www.xerox.com/privacy#cookies"
        target="_blank"
        xdaTranslate
        >SDE_PRIVACY_POLICY</a
      >&nbsp;<span xdaTranslate>SDE_FOR_MORE_INFORMATION4</span>
    </div>
    <span class="notice-close"
      ><i class="xrx-glyph xrx-close" (click)="close()"></i
    ></span>
  </div>
}
